module.exports = __webpack_public_path__ + "img/forgot-password.3c35949f.svg";